<template>
  <div>
    <HeaderControls :myWeek='false' :parentDeliverableId="parentDeliverableId" @filterUpdated='filterUpdate'
      @collapseToggleUpdated='collapseToggleUpdate' @showEditDeliverableModal="showEditDeliverableModal"
      :namespace="namespace" :tabTitle="tabTitle" ref="refHeaderControls" :showLogo="showLogo" />
    <div class="deliverable-main container-fluid">


      <b-modal size="lg" no-close-on-backdrop hide-footer id="editSocialModal" title="Edit Related Social Deliverable"
        class="modal-edit-social-deliverable" @show="editSocialModalShown" @shown="afterEditSocialModalShown"
        @hide="editSocialModalHidden" @hidden="removeRoute" no-close-on-esc>
        <EditSocialModal :allContacts="allContacts" :tabIndex="tabIndex" ref="refEditRelatedSocialModal"
          @modalDetailUpdated="pushRoute" :namespace="namespace" />
      </b-modal>

      <SocialScheduleCalendar v-if="systemSettingsReady" :myWeek="false" :expandAll="expandAll"
        @collapseToggleUpdated='collapseToggleUpdate' :namespace="namespace" :parentDeliverableId="parentDeliverableId"
        ref="refSocialScheduleCalendar" @showEditDeliverableModal="showEditDeliverableModal" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import HeaderControls from "../common/HeaderControlsRelatedDeliverablesSocialCalendar";
import SocialScheduleCalendar from "./SocialScheduleCalendar";
import EditSocialModal from "./EditSocialModal";


export default {
  data() {
    return {
      expandAll: !this.isMobile(),
      systemSettingsReady: false,
      tabIndex: 0,
      selectedDeliverable: false,
    }
  },
  props: {
    parentDeliverableId: Number,
    namespace: String,
    tabTitle: String,
    showLogo: Boolean,
  },
  computed: {
    ...mapState({
      state(state) {
        return state[this.namespace]
      },
      allCustomFields(state, getters) {
        return getters[this.namespace + 'allCustomFields']
      },
      allUsers(state, getters) {
        return getters['allUsers']
      },
      systemSettings(state, getters) {
        return getters['systemSettings']
      },
      allContacts(state, getters) {
        return getters[this.namespace + 'allContacts']
      },
      deliverableDetail(state, getters) {
        return getters[this.namespace + 'deliverableDetail']
      },

    }),
    forceUpdateCounter() {
      return this.deliverables.forceUpdateCounter;
    },
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function (item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    }
  },
  components: {
    SocialScheduleCalendar,
    HeaderControls,
    EditSocialModal
  },
  methods: {
    ...mapActions({
      fetchSystemSettings(dispatch, payload) {
        return dispatch('fetchSystemSettings', payload)
      },
    }),
    filterUpdate(filterQuery) {
      this.filterQuery = filterQuery
    },

    pushRoute() {
      return;
      if (this.isListView) {
        history.pushState(
          {},
          null,
          '/social-media/' + encodeURIComponent(this.deliverableDetail.id) + (this.deliverableDetail.slug ? ('/' + encodeURIComponent(this.deliverableDetail.slug) + '/') : '')
        )
      } else {
        history.pushState(
          {},
          null,
          '/social-media-grouped/' + encodeURIComponent(this.deliverableDetail.id) + (this.deliverableDetail.slug ? ('/' + encodeURIComponent(this.deliverableDetail.slug) + '/') : '')
        )
      }
      let currentTitle = document.title.match(/\(\d+\)\s/g);
      if (!currentTitle) {
        document.title = this.deliverableDetail.title;
      } else {
        document.title = currentTitle[0] + this.deliverableDetail.title;
      }
    },

    removeRoute() {
      history.pushState(
        {},
        null,
        this.$router.currentRoute.matched[0].path
      );
    },

    editSocialModalShown() {
      document.body.classList.add("social-modal-open");
      $("#content").scrollTop(this.windowScrollTop);
    },
    afterEditSocialModalShown() {
      document.body.classList.add("social-modal-shown");
    },
    editSocialModalHidden() {
      this.windowScrollTop = $("#content").scrollTop();
      document.body.classList.remove("social-modal-open");
      document.body.classList.remove("social-modal-shown");
      $(window).scrollTop(this.windowScrollTop);
      this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail);
      this.$store.commit(this.namespace + 'setCalendarDeliverable', this.deliverableDetail);
      this.selectedDeliverable = false;

    },

    showEditDeliverableModal(deliverable, tab) {
      this.windowScrollTop = $(window).scrollTop();
      let deliverableId = null;
      if (typeof deliverable === "object") {
        deliverableId = deliverable.id;
        this.selectedDeliverable = deliverable.id;
        if (deliverable.social_series.length && !deliverable.manually_updated_at) {
          deliverableId = this.getSeriesMasterByDeliverable(deliverable);
        }
      } else {
        deliverableId = deliverable;
        this.selectedDeliverable = deliverableId;
      }
      if (tab === null || tab === undefined) {
        tab = 2;
      }
      let mId;
      if (this.namespace != "") {
        mId = "editRelatedSocialModal";
      } else {
        mId = "editSocialModal";
      }

      console.log("tab", tab);
      console.log("mId", mId);


      this.$store.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
        .then(() => {
          this.pushRoute();
          this.$bvModal.show(mId, {
            backdrop: 'static',
            keyboard: true,
          });
          this.tabIndex = tab;
        });
      this.$root.$emit('bv::modal::disable-pointer-events');
    },
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    },
    checkSystemSettingsReady() {
      if (this.systemSettings.publish_statuses) {
        this.systemSettingsReady = true;
      } else {
        this.systemSettingsReady = false;
      }
    },
    getSeriesMasterByDeliverable(deliverable) {
    	if (typeof deliverable.social_series_deliverables != "undefined") {
	      let series = deliverable.social_series_deliverables;
	      if (series.length) {
	        let master = series.find(x => x.is_master === 1);
	        if (master) {
	          return master.id;
	        }
	      }
	    }
      return false;
    },

  },
  mounted() {
    document.body.classList.add("social-media");
  },
  created() {
    this.fetchSystemSettings();
    this.checkSystemSettingsReady();
  },
  watch: {
    systemSettings(to, from) {
      this.checkSystemSettingsReady();
    },
  }
}
</script>
